import { batchQueryActivityExtInfo } from './batchQueryActivityExtInfo';
import { collect } from './collect';
import { page } from './page';
import { tags } from './tags';

export default {
  batchQueryActivityExtInfo,
  collect,
  page,
  tags,
};
